import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import Index from './vue_components/Page/Index';
import Services from './vue_components/InsidePages/Services/Services';
import Service from './vue_components/InsidePages/Services/Service';
import News from './vue_components/InsidePages/News/News';
import NewsOnce from './vue_components/InsidePages/News/NewsSingle';
import Useful from './vue_components/InsidePages/Useful/Useful';
import UsefulSingle from './vue_components/InsidePages/Useful/UsefulSingle';
import Contacts from './vue_components/InsidePages/Contacts/Contacts';
import E404 from './vue_components/E404'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Index,
        props: true,
        meta: {
            title: 'Перспектива - Главная'
        }
    },
    {
        path: '/services',
        name: 'Services',
        component: Services,
        meta: {title: 'Услуги'},
        props: true,
        children: [
            {
                path: ':slug',
                name: 'ServicesInside',
                component: Service,
                meta: {title: 'Услуги', modal: true},
                props: true
            }
        ]
    },
    {
        path: '/news',
        name: 'News',
        component: News,
        props: true,
        meta: {title: 'Новости'},
        children: [
            {
                path: ':slug',
                name: 'NewsInside',
                component: NewsOnce,
                meta: {title: 'Новости', modal: true},
                props: true
            }
        ]
    },
    {
        path: '/useful',
        name: 'Useful',
        component: Useful,
        props: true,
        meta: {title: 'Полезное'},
        children: [
            {
                path: ':slug',
                name: 'UsefulInside',
                component: UsefulSingle,
                meta: {title: 'Полезное', modal: true},
                props: true
            }
        ]
    },
    {
        path: '/contacts',
        name: 'Contacts',
        component: Contacts,
        meta: {
            title: 'Контакты'
        }
    },
    {
        path: '*',
        name: '404',
        component: E404,
        meta: {
            title: 'Ничего не найдено :('
        }
    },
];



export const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        // let feedbackButton = document.querySelector('.t-feedBackBtnWrapper');
        // let feedbackDefaultPosition = 48;
        // feedbackButton.style.bottom = `${feedbackDefaultPosition}px`;

        // console.log(to.params)
        // if (to.params&&to.params.toTop) {
        //     console.log(to.params.toTop)
        //     return {x: 0, y: 0};
        // } 
        // if (to.hash) {
        //     return {
        //         selector: to.hash
        //     }
        // }
        if( (to.name === 'Services' && from.name === 'ServicesInside')
            || (to.name === 'News' && from.name === 'NewsInside')
            || (to.name === 'Useful' && from.name === 'UsefulInside')
            || (to.name === 'ServicesInside' && from.name === 'Services')
            || (to.name === 'NewsInside' && from.name === 'News')
            || (to.name === 'UsefulInside' && from.name === 'Useful')
            || (to.name === 'News' && from.name === 'News')
            || (to.name === 'Services' && from.name === 'Services')
            || (to.name === 'Useful' && from.name === 'Useful')
        ) {
            return savedPosition
        } else {
            return {x: 0, y: 0};
        }
    }
});


router.beforeEach((to, from, next) => {
    // const 
    if(to.meta.modal){
        document.body.classList.add('t-modalIsOpen'); // отключить скролл при открытом диалоговом окне
    } else {
        document.body.classList.remove('t-modalIsOpen');
    }
    next();
});


// WEBPACK FOOTER //
// ./src/routes.js